import { Flexi } from "slotworks/graphics/elements/abstract-flexi";
import BitmapText from "slotworks/graphics/pixi/bitmap-text";
import { Services } from "slotworks/services/services";

export default class FlexiText extends Flexi<PIXI.Text | HTMLElement | BitmapText> {
    private autoResize: boolean = false;
    private visible: boolean = true;

    public setText(text: string) {
        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                target.textContent = text;
                target.innerHTML = Services.translations.convertTags(target.textContent);

                if (this.autoResize) {
                    this.resizeText(target);
                }
            } else {
                target.text = text;
            }
        }
    }

    public setAutoResize(autoresize: boolean) {
        this.autoResize = autoresize;

        if (this.autoResize) {
            window.addEventListener("resize", this.resizeAllTargets);
        } else {
            window.removeEventListener("resize", this.resizeAllTargets);
        }

        this.resizeAllTargets();
    }

    public setAlpha(alpha: number) {
        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                target.style.opacity = alpha.toString();
            } else {
                target.alpha = alpha;
            }
        }
    }

    public setVisible(visible: boolean) {
        for (const target of this.targets) {
            if (target instanceof HTMLElement) {
                target.classList.toggle(visible ? "hidden" : "visible", false);
                target.classList.toggle(visible ? "visible" : "hidden", true);
            } else {
                target.visible = visible;
            }
        }

        this.visible = visible;
    }

    public getVisible(): boolean {
        return this.visible;
    }

    private resizeAllTargets = () => {
        if (this.autoResize) {
            for (const target of this.targets) {
                if (target instanceof HTMLElement) {
                    this.resizeText(target);
                }
            }
        }
    }

    private resizeText(element: HTMLElement): void {
        element.style.setProperty("font-size", "100%");

        let fontSize = 100;

        while (
            ((element.scrollWidth > element.clientWidth || element.scrollHeight > element.clientHeight) ||
            (element.scrollWidth > element.offsetWidth || element.scrollHeight > element.offsetHeight)) &&
            fontSize > 5
            ) {
            fontSize *= .95;
            element.style.setProperty("font-size", fontSize + "%");
        }
    }
}
